import React, { useContext, useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../../assests/images/launch-wild-logo.png";
import { SidebarContext } from "../../../contexts/SidebarContext";
import { VscAccount } from "react-icons/vsc";
import { MdSubscriptions } from "react-icons/md";
import { FcProcess } from "react-icons/fc";
import { FaList } from "react-icons/fa";
import "./Sidebar.scss";

const Sidebar = () => {
  const { activeMenu, setActiveMenu } = useContext(SidebarContext);
  const [userRole, setUserRole] = useState(localStorage.userDetails && JSON.parse(localStorage.userDetails).role);
  const isMounted = useRef(false);

  async function getUserRole() {
    try {
      // const response = await axiosOpen.get("user/getUserRole");
      if (isMounted.current) {
        // setUserRole("superadmin")
      }
    } catch(error) {
      console.log(error);
    }
  }


  useEffect(() => {
    isMounted.current = true;
    getUserRole()
    return () => {
      isMounted.current = false;
    }
  }, [])
  


  return (
    <div className={activeMenu ? "sidebar d-flex bg-dark hide" : "sidebar d-flex bg-dark"}>
      <div className="d-flex flex-column flex-shrink-0 px-3 text-white w-100">
        <a href={`${userRole === 'superadmin' ? '/subscription/list' : '/'}`} className="d-flex align-items-center justify-content-center mt-3 mb-4">
          <img alt="Amazon openai" src={logo} width="120" />
        </a>

        <nav className="h-100vh">
          {
            userRole === "superadmin" && (<ul className="nav nav-pills flex-column mb-auto">
              <li>
                <NavLink
                  to="/subscription/list"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <MdSubscriptions style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">subscription plans</span>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/usersPrompts"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <MdSubscriptions style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">Users prompts</span>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/customPrompts"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <MdSubscriptions style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">Custom prompts</span>
                  </div>
                </NavLink>
              </li>
            </ul>)
          }
          {
            userRole === "user" && (<ul className="nav nav-pills flex-column mb-auto">
              <li className="nav-item">
                <NavLink
                  end={true}
                  to="/profile"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <VscAccount style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">Account</span>
                  </div>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/subscription-plans"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <MdSubscriptions style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">subscription plans</span>
                  </div>
                </NavLink>
              </li>

              <li>
                <NavLink to="/" className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}>
                  <div className="d-flex align-items-center">
                    <FcProcess style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">Scrape Data</span>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/analysed-products"
                  className={({ isActive }) => `nav-link text-white ${isActive ? "active" : undefined}`}
                >
                  <div className="d-flex align-items-center">
                    <FaList style={{ fontSize: "20px" }} />
                    &nbsp;&nbsp;
                    <span className="text-capitalize">Saved Data</span>
                  </div>
                </NavLink>
              </li>
            </ul>)
          }
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
